import React from "react";
import "../../../src/style/block.scss";
import "./style.scss";

const ShopNotWorking: React.FC = () => {
  return (
    <div className="flex-center-center">
      <div className="flex-center flex-column shop-not-working shadow">
        <h3>Wystapił problem z załadowaniem sklepu</h3>
        <article>Brak konfiguracji</article>
      </div>
    </div>
  );
};

export default ShopNotWorking;
